import { useSelector } from 'react-redux';
import { useContext, useEffect, useRef, useState } from 'react';
import isEqual from 'lodash/isEqual';
import { ProfileContext } from 'context';
import { getStandards } from 'helpers/standards';
import { useAction } from 'hooks';
import Account from 'modules/Account';
import Hcp from 'modules/Hcp';
import ClinicManagement from 'modules/ClinicManagement';
import CloudDrive from 'modules/CloudDrive';
import * as selectors from '../../selectors';
export const useSyncData = (patientId)=>{
    const profileContext = useContext(ProfileContext);
    const countrySettings = useSelector(Account.selectors.countrySettings);
    const clinicSettings = useSelector(ClinicManagement.selectors.clinicSettings);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const activePatient = useSelector(Hcp.selectors.activePatient);
    const phiSetDocumentId = useSelector(Hcp.selectors.phiSetDocumentId);
    const phiSetPatientId = useSelector(Hcp.selectors.phiSetPatientId);
    const sharingRequest = useSelector(Hcp.selectors.sharingRequest);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const deviceMode = useSelector(selectors.deviceMode);
    const activePatientIdRef = useRef(null);
    const onFetchPhiSet = useAction(CloudDrive.actions.fetchPhiSet);
    const [standards, setStandards] = useState(null);
    const [statePatientId, setPatientId] = useState(null);
    useEffect(()=>{
        if (!activePatient) {
            return;
        }
        const { id, phiSetReferenceKey } = activePatient;
        if (id === activePatientIdRef.current || !phiSetReferenceKey) {
            return;
        }
        activePatientIdRef.current = id;
        onFetchPhiSet(activePatient, Hcp.actions.setPhiSet);
    }, [
        activePatient
    ]);
    useEffect(()=>{
        const isAGP = deviceMode === 'AGP';
        const newPhiSet = !isAGP ? phiSet : null;
        const newStandards = getStandards(newPhiSet, countrySettings, clinicSettings, isAGP);
        if (!isEqual(standards, newStandards) || patientId !== statePatientId) {
            setStandards(newStandards);
            setPatientId(patientId);
        }
    }, [
        deviceMode,
        phiSet
    ]);
    if (!activePatient || !phiSet || !phiSetPatientId) {
        return null;
    }
    const { storageProvider, phiSetReferenceKey, accessToken } = activePatient;
    return {
        accessToken,
        activePatient,
        phiSet,
        phiSetDocumentId,
        phiSetReferenceKey,
        phiSetPatientId,
        sharingRequest,
        activeClinicMembership,
        standards,
        storageProvider
    };
};
